import create from "zustand";

interface State {
	showCoursesTab: boolean;
}

interface Actions {
	setShowCoursesTab: (showCoursesTab: boolean) => void;
}

export const useCoursesStore = create<State & Actions>((set) => ({
	showCoursesTab: false,
	setShowCoursesTab: (showCoursesTab) => {
		set(() => ({ showCoursesTab: showCoursesTab }));
	},
}));
